













































































































































import Vue, { PropType } from 'vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import { ShippingAddress } from '@/types/generated/graphql'

export default Vue.extend({
  name: 'ShippingAddressItem',
  components: { XButton, XCard },
  props: {
    shippingAddress: {
      type: Object as PropType<ShippingAddress>,
      required: true,
    },
  },
  methods: {
    onChangeMain(id: string) {
      this.$emit('changeMain', id)
    },
    onHandleEdit(id: string) {
      this.$router.push({ name: 'ShippingAddressEdit', params: { id: id } })
    },
    onDelete(id: string) {
      this.$emit('delete', id)
    },
  },
})
